import { faFlag, faFlask, faMicrochip } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Observation } from '../../types'
import { titleUndeletableObservation } from '../ObservationsSelectField/utils'
import useStyles from './ThumbTemplate.styles'

export interface ThumbTemplateProps {
  alt: string
  src: string
  fileName: string
  tagDecorator?: React.ReactNode
  tagIconDecorator?: React.ReactNode
  imageContent?: React.ReactNode
  onMouseEnterImage?: () => void
  onMouseLeaveImage?: () => void
  observation: Observation
  isDisabled?: boolean
}

export const ThumbTemplate = ({
  alt,
  src,
  fileName,
  tagDecorator,
  tagIconDecorator,
  imageContent,
  onMouseEnterImage,
  onMouseLeaveImage,
  observation,
  isDisabled,
}: ThumbTemplateProps) => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <span
      title={
        isDisabled
          ? t(
              'Not available since including images used in the training process would artificially increase the performance of this test'
            )
          : ''
      }
      className={classes.thumb}
    >
      <span
        className={classes.image}
        onMouseEnter={onMouseEnterImage}
        onMouseLeave={onMouseLeaveImage}
      >
        <img alt={alt} src={src} />

        {imageContent}
      </span>
      <span className={classes.bottom}>
        <span className={classes.fileName} title={fileName}>
          {fileName}
        </span>

        <span className={classes.tagsRow}>
          <span>{tagDecorator}</span>
          <span className={classes.iconsRow}>
            {tagIconDecorator}
            {observation.annotationIsPromoted && (
              <FontAwesomeIcon
                icon={faMicrochip}
                title={t('Annotation promoted to ground truth')}
              />
            )}

            {observation.trainingIds.length > 0 && (
              <FontAwesomeIcon
                className={classes.usedForTrainTest}
                title={titleUndeletableObservation(observation.trainingIds, [])}
                icon={faFlag}
              />
            )}
            {observation.trainingTestIds.length > 0 && (
              <FontAwesomeIcon
                className={classes.usedForTrainTest}
                title={titleUndeletableObservation(
                  [],
                  observation.trainingTestIds
                )}
                icon={faFlask}
              />
            )}
          </span>
        </span>
      </span>
    </span>
  )
}

export default ThumbTemplate
